import { MutationFn, UseQueryFn } from 'shared-ui';

import { PaginatedResponse } from 'core/global.types';

import {
  UserPermissionsResponse,
  UpdateUserFunctionalPermissionsRequest,
  UpdateUserFunctionalPermissionsResponse,
  UpdateUserFunctionalPermissionsBody,
  UserDataPermissionsResponse,
  UpdateUserDataPermissionsRequest,
  UpdateUserDataPermissionsBody,
  UserAccessFlags,
  UpdateUserAccessFlagsRequest,
  UserPermissionsHistory,
  UserAccessSettingsResponse,
  UpdateUserAccessSettingsRequest,
} from './userPermissions.types';

export const fetchUserFunctionalPermissions: UseQueryFn<string, UserPermissionsResponse> = (userId) => {
  return {
    endpoint: `/user/${userId}/permissions`,
  };
};

export const updateUserFunctionalPermissions: MutationFn<
  UpdateUserFunctionalPermissionsRequest,
  UpdateUserFunctionalPermissionsResponse
> = ({ userId, permissions }) => {
  return {
    endpoint: `/user/${userId}/permissions`,
    method: 'PUT',
    body: { permissions } as UpdateUserFunctionalPermissionsBody,
  };
};

export const fetchUserDataPermissions: UseQueryFn<string, UserDataPermissionsResponse> = (userId) => {
  return {
    endpoint: `/user/${userId}/data-permissions`,
  };
};

export const updateUserDataPermissions: MutationFn<UpdateUserDataPermissionsRequest, UserDataPermissionsResponse> = ({
  userId,
  selectedOrganizations,
}) => {
  return {
    endpoint: `/user/${userId}/data-permissions`,
    method: 'PUT',
    body: {
      permissions: selectedOrganizations.map((komorkaId) => ({ komorkaId })),
    } as UpdateUserDataPermissionsBody,
  };
};

export const fetchUserAccessFlags: UseQueryFn<string, UserAccessFlags> = (userId) => {
  return {
    endpoint: `/user/${userId}/access-flags`,
  };
};

export const updateUserAccessFlags: MutationFn<UpdateUserAccessFlagsRequest, UserAccessFlags> = ({
  userId,
  accessFlags,
}) => {
  return {
    endpoint: `/user/${userId}/access-flags`,
    method: 'PUT',
    body: accessFlags,
  };
};

export const fetchUserAccessSettings: UseQueryFn<string, UserAccessSettingsResponse> = (userId) => {
  return {
    endpoint: `/user/${userId}/access-settings`,
  };
};

export const updateUserAccessSettings: MutationFn<UpdateUserAccessSettingsRequest, UserAccessSettingsResponse> = ({
  userId,
  accessAllData,
  accessFeaturedCards,
  accessNoOrganizations,
  permissions,
}) => {
  return {
    endpoint: `/user/${userId}/access-settings`,
    method: 'PUT',
    body: {
      accessAllData,
      accessFeaturedCards,
      accessNoOrganizations,
      permissions,
    },
  };
};

export const fetchUserPermissionsHistory: UseQueryFn<string, PaginatedResponse<UserPermissionsHistory>> = (userId) => {
  return {
    endpoint: `/user/${userId}/permissions-history`,
  };
};
